<template>
  <v-card
    class="action-card rounded-lg d-flex align-center justify-center"
    :class="{ 'mb-4': $vuetify.breakpoint.mdAndDown }"
    color="primary"
    flat
    min-height="200"
    @click="action.action"
  >
    <div class="z-index-1 text-center">
      <v-btn icon color="transparent">
        <hm-icon height="43" width="47">
          <component :is="action.icon" />
        </hm-icon>
      </v-btn>
      <div class="text-h6 white--text font-weight-regular">
        {{ action.title }}
      </div>
    </div>
  </v-card>
</template>

<script>
import HmIcon from "@/components/HmIcon.vue";
import PlusCircleIcon from "@/components/icons/PlusCircleIcon.vue";
  import WithdrawIcon from "@/components/icons/WithdrawIcon.vue";

export default {
  props: {
    action: {
      type: Object,
    },
  },
  components: {
      HmIcon,
      PlusCircleIcon,
      WithdrawIcon
  }
};
</script>

<style lang="scss" scoped>
.action-card {
  position: relative;
  background: black;
  overflow: hidden;

  &:after {
    content: "";
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 150px 200px 0;
    border-color: transparent #234e57 transparent transparent;
    right: 0;
    top: 0;
    position: absolute;
  }
}
</style>